<script>
import { mapState, mapActions } from 'vuex';
/* components */
import CheckMail from '@/components/CheckMail';
/* tools */
import {} from '@/scripts/utils';
import { goTo } from '@/scripts/methods';
import { unsubscribe } from '@/scripts/api/users';

export default {
  name: 'Unsubscribe',
  components: {
    CheckMail,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      done: false,
    };
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.fillDataFromUrl();
  },
  mounted() {},
  destroyed() {
    clearTimeout(this.redirectId);
  },
  methods: {
    ...mapActions({
      setError: 'setError',
      setErrorCloseCallback: 'setErrorCloseCallback',
    }),
    fillDataFromUrl() {
      /*  */
      const urlParams = new URLSearchParams(window.location.search);
      const email = urlParams.get('email');
      const userHash = urlParams.get('userHash');
      const subscription = urlParams.get('subscription');
      const payload = {
        email,
        userHash,
        subscription,
      };

      if (!email || !userHash || !subscription) {
        console.warn(`payload = `);
        console.dir(payload);

        this.setError('Parameters not provided');
        this.setErrorCloseCallback(this.leave);

        /* async */
        this.redirectId = setTimeout(() => {
          /* TODO: turn off in tests */
          this.setError(null);
          this.leave();
        }, 5000);

        return;
      }

      this.payload = payload;
      this.sendRequest(payload);
    },
    sendRequest(payload = this.payload) {
      return unsubscribe(payload)
        .then(() => {
          this.done = true;

          setTimeout(() => {
            this.leave();
          }, 3000);
        })
        .catch(() => {
          this.setErrorCloseCallback(this.leave);

          /* async */
          this.redirectId = setTimeout(() => {
            this.setError(null);
            this.leave();
          }, 5000);
        });
    },
    leave() {
      this.goTo('/', { method: 'replace' });
    },
    goTo,
  },
};
</script>

<template>
  <div class="unsubscribe">
    <CheckMail
      v-if="done"
      title="It’s not the same without you!"
      subTitle="While we're sorry to see you go. We'll be here waiting to help you get reacquainted."
    />
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';

.unsubscribe {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  height: 100%;
}

/* mobile */
@media (max-width: $mobile) {
}
</style>
